import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children, requireRole, requireMenu }) {
  const { isAuthenticated, loading, isSuperAdmin, isCompanyAdmin, hasMenuAccess } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (requireRole === 'SUPER_ADMIN' && !isSuperAdmin()) {
    return <Navigate to="/" replace />;
  }

  if (requireRole === 'COMPANY_ADMIN' && !isCompanyAdmin()) {
    if (!requireMenu || !hasMenuAccess(requireMenu)) {
      return <Navigate to="/" replace />;
    }
  }

  return children ?? <Outlet />;
}

export default ProtectedRoute;
